<template>
  <div class="quick-links">
    <div class="home"><i class="el-icon-s-home"></i><span class="homename" @click="redirectHomePage()">首页</span></div>
    <div class="infonews" v-if="enterpriseButton"><i class="el-icon-bell"></i><span class="infoname" @click="showMessageList()">消息</span><span v-if="unreadMessageCount>0" class="infonum">{{unreadMessageCount}}</span></div>
    <el-dropdown @command="handleCommand" placement="bottom-start" class="user-management">
      <div class="user">
        <avatar icon="el-icon-user-solid" class="avatar" />
        <span class="username">{{!!userInfo && !!userInfo.name ? userInfo.name + '，' : ''}}欢迎您</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <!-- <el-dropdown-item icon="el-icon-s-home" v-if="enterpriseButton" @click.native="showEterprise = true">企业信息</el-dropdown-item> -->
        <el-dropdown-item icon="el-icon-s-home" v-if="enterpriseButton" @click.native="getEnterprise">我的企业</el-dropdown-item>
        <el-dropdown-item icon="el-icon-user" @click.native="getUserInfo">个人中心</el-dropdown-item>
        <!-- <el-dropdown-item icon="el-icon-setting" @click.native="changePassword">充值记录</el-dropdown-item> -->
        <el-dropdown-item icon="el-icon-lock" @click.native="changePassword">修改密码</el-dropdown-item>
        <el-dropdown-item icon="el-icon-switch-button" command="logout_click">退出登录</el-dropdown-item>
      </el-dropdown-menu>
      <changePassword caller="userCenter"></changePassword>
    </el-dropdown>
    <messageList></messageList>
    <!-- <div class="instal"><i class="el-icon-s-tools"></i><span class="instalname">设置</span></div> -->
    <el-dialog v-dialogDrag :title="enterpriseInfoTitle + enterprise.enterpriseName" v-if="showEterprise" :visible.sync="showEterprise" width="55%">
      <div class="el-group-page el-group-page--gray-backgound">
        <el-row>
          <el-col :span="24">
            <div class="el-group-panel">
              <el-row>
                <el-col :span="24"><div class="el-panel-title"><span>基本信息</span></div></el-col>
              </el-row>
              <div>
                <el-row class="el-panel-body"><span class="el-attr-label">企业简称：</span><span class="el-attr-value">{{enterprise.enterpriseShortName}}</span></el-row>
                <el-row class="el-panel-body"><span class="el-attr-label">委托授权人：</span><span class="el-attr-value">{{enterprise.userName}}</span></el-row>
                <el-row class="el-panel-body"><span class="el-attr-label">社会信用代码：</span><span class="el-attr-value">{{enterprise.certificateCode}}</span></el-row>
                <el-row class="el-panel-body"><span class="el-attr-label">法定代表人：</span><span class="el-attr-value">{{enterprise.legalName}}</span></el-row>
                <el-row class="el-panel-body"><span class="el-attr-label">企业规模：</span><span class="el-attr-value">{{enterprise.enterpriseScale}}人</span></el-row>
                <el-row class="el-panel-body"><span class="el-attr-label">所属地区：</span><span class="el-attr-value">{{enterprise.districtName}}</span></el-row>
                <el-row class="el-panel-body"><span class="el-attr-label">详细地址：</span><span class="el-attr-value">{{enterprise.address}}</span></el-row>
                <el-row class="el-panel-body"><span class="el-attr-label">发票品目：</span><span class="el-attr-value">{{enterprise.invoiceItems}}</span></el-row>
              </div>
              <el-row class="el-panel-body">
                <span class="el-attr-label">授权委托书：</span>
                <el-card :body-style="{ padding: '0px' }" class="el-card-img">
                  <el-image class="img" :src="enterprise.authorizationFilePath" :fit="enterprise.authorizationFilePathImageFit"></el-image>
                </el-card>
              </el-row>
              <el-row class="el-panel-body">
                <span class="el-attr-label">营业门头照：</span>
                <el-card :body-style="{ padding: '0px' }" class="el-card-img">
                  <el-image class="img" :src="enterprise.billboardFilePath" :fit="enterprise.billboardFilePathImageFit"></el-image>
                </el-card>
              </el-row>
                <el-row class="el-panel-body">
                  <span class="el-attr-label">营业执照：</span>
                  <el-card :body-style="{ padding: '0px' }" class="el-card-img">
                    <el-image class="img" :src="enterprise.certificateFilePath" :fit="enterprise.certificateFilePathImageFit"></el-image>
                  </el-card>
                </el-row>
                <el-row class="el-panel-body">
                  <span class="el-attr-label">办公场所照：</span>
                  <el-card :body-style="{ padding: '0px' }" class="el-card-img">
                    <el-image class="img" :src="enterprise.officeSpaceFilePath" :fit="enterprise.officeSpaceFilePathImageFit"></el-image>
                  </el-card>
                </el-row>
              </div>
            </el-col>
        </el-row>
        <el-row v-if="enterprise.enableRecharge == 1 ">
          <el-col :span="24">
            <div class="el-group-panel">
              <el-row>
                <el-col :span="24"><div class="el-panel-title"><span >开户行信息</span></div></el-col>
              </el-row>
              <el-row class="el-panel-body"><span class="el-attr-label">企业开户行：</span><span class="el-attr-value">{{enterprise.enterpriseBankName}}</span></el-row>
              <el-row class="el-panel-body"><span class="el-attr-label">企业户名：</span><span class="el-attr-value">{{enterprise.enterpriseAccountName}}</span></el-row>
              <el-row class="el-panel-body"><span class="el-attr-label">企业银行账号：</span><span class="el-attr-value">{{enterprise.enterpriseAccountNumber}}</span></el-row>

            </div>
          </el-col>
        </el-row>
        <el-row v-if="enterprise.enableRecharge == 1 ">
          <el-col :span="24">
            <div class="el-group-panel">
              <el-row>
                <el-col :span="24"><div class="el-panel-title"><span>平台账户信息</span></div></el-col>
              </el-row>
              <el-row class="el-panel-body"><span class="el-attr-label">平台开户行：</span><span class="el-attr-value">{{enterprise.platformBankName}}</span></el-row>
              <el-row class="el-panel-body"><span class="el-attr-label">平台户名：</span><span class="el-attr-value">{{enterprise.platformAccountName}}</span></el-row>
              <el-row class="el-panel-body"><span class="el-attr-label">平台银行账号：</span><span class="el-attr-value">{{enterprise.platformAccountNumber}}</span></el-row>
            </div>
            </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="showEterprise = false">关闭</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog v-dialogDrag title="个人中心" v-if="showUserInfo" :visible.sync="showUserInfo" width="40%">
      <div class="el-group-page el-detail-page--gray-backgound" style="height:25vh">
        <el-row style="margin-left:2vw;margin-top:3vh">
          <el-col :span="24">
            <div class="el-info-panel">
              <el-row class="el-panel-body" style="width: 100%"><span class="el-attr-label">姓名：</span><span class="el-attr-value">{{ userInfo.name }}</span></el-row>
              <el-row class="el-panel-body" style="width: 100%"><span class="el-attr-label">身份证号码：</span><span class="el-attr-value">{{ userInfo.idCardNumber }}</span></el-row>
              <el-row class="el-panel-body" style="width: 100%"><span class="el-attr-label">手机号：</span><span class="el-attr-value">{{ userInfo.mobilePhone }}
                <el-link class="el-userInfo-link" @click="showCurrencyPhoneCode">修改</el-link>
              </span></el-row>
              <el-row class="el-panel-body" style="width: 100%"><span class="el-attr-label">邮箱：</span><span class="el-attr-value">{{ userInfo.email }}
                <el-link class="el-userInfo-link" @click="showUpdateEmail">修改</el-link></span></el-row>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showUserInfo = false">关闭</el-button>
      </div>
      <!-- 修改邮箱 -->
      <el-dialog v-dialogDrag width="30%" title="修改邮箱" @close="closeEmailDialog" :visible.sync="validEmailVisible" v-if="validEmailVisible" append-to-body>
        <el-form :model="form" style="padding-top: 2vh" :rules="rules" ref="form" label-width="70px" class="">
          <el-form-item prop="email" label="邮箱：">
            <el-input :maxlength=30 v-model="form.email"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('form')">确定</el-button>
          <el-button @click="closeEmailDialog">取消</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <!-- 手机发送短信组件 -->
      <currencyPhoneCode @oldValidPass="oldValidPass" @newValidPass="newValidPass" @resertData="resertData"></currencyPhoneCode>
  </div>
</template>

<script>
import { Avatar } from 'element-ui'
import { removeToken } from '@/utils/auth'
import { getToken, setToken } from '@/utils/auth'
import currencyPhoneCode from '@/components/PhoneVerificationCode/currencyPhoneCode'  //手机号发送验证码组件
import messageList from './messageList'
import changePassword from './changePassword'
import SystemMessage from '@/views/home/enterprise/systemMessage'
import {getCookie,setCookie} from '@/utils/cookie'
export default {
  name: 'index',
  data(){
    //验证新邮箱号与旧邮箱号是否相同
        let newOldEmail = (rule, value, callback) => {
          if (this.userInfo.email==this.form.email) {
          callback(new Error('新邮箱号与旧邮箱号不能相同'));
          } else {
          callback();
          }
        };
    return{
      //我的企业
      enterpriseInfoTitle:'企业 - ',//企业信息弹窗标题
      enterpriseButton:false,//是否显示我的企业
      showEterprise:false,//控制企业信息弹窗的显示
      enterprise:{},//企业信息对象
      imageFit: 'contain', // 图片展示方式 填满_fill, 宽度自适应_contain
      //个人中心
      showUserInfo:false,//控制个人中心弹窗的显示
      userInfo:{},//个人中心对象
      validEmailVisible:false,//控制修改邮箱弹窗的显示
      form:{email:''},//邮箱对象
      rules:{
           email:[
            { required: true, message: '请输入新的邮箱', trigger: 'blur' },
            { type: 'email', message: '邮箱格式错误', trigger: ['blur', 'change'] },
            {validator: newOldEmail, message: '新邮箱号与旧邮箱号不能相同', trigger: 'blur'}
          ],
      },
      //新的短信组件，必传的三个参数
      mobilePhone:{
        verificationType:'currency', //验证码类型
        mobilePhone:undefined,       //要回显的手机号
        oldMobilePhone:undefined,   //旧手机号
        phoneTitle:''   //弹窗标题
      },
      //消息相关的信息
      unreadMessageCount:undefined,//未读消息数
      systemMessageList:[],//消息列表
      lastMsgID:undefined,//记录的最大的一个id
      differTime:null,  //服务器端的时间与客户端相差的毫秒数
      timer: null,//定时器——定时（10s）获取消息
    }
  },
  components: {
    Avatar,
    changePassword,
    // PhoneVerificationCode,
    currencyPhoneCode,
    SystemMessage,
    messageList
  },
  methods: {
    // 重定向到首页
    redirectHomePage(){
      //根据登录类型判断跳转哪个首页
      if(getCookie('leftTitle')=='我是企业'){
        this.$router.push({
        path: '/admin/home/enterprise/index',
      })
      }else if(getCookie('leftTitle')=='我是平台'){
        this.$router.push({
        path: '/admin/home/platform/index',
      })
      }else if(getCookie('leftTitle')=='我是政府'){
        this.$router.push({
        path: '/admin/home/platform/index',
      })
      }
    },
    showUpdateEmail(){
        //查询数据库
        this.getUserInfo();
        this.validEmailVisible = true
    },
    //短信弹窗关闭，刷新数据
    resertData(){
      this.mobilePhone.verificationType='currency';
      this.mobilePhone.mobilePhone=undefined;
      this.mobilePhone.oldMobilePhone=undefined;
      this.mobilePhone.phoneTitle='';
    },
    showCurrencyPhoneCode() {
      //查询数据库
      this.getUserInfo();
      this.mobilePhone.mobilePhone=this.userInfo.mobilePhone;
      this.mobilePhone.phoneTitle='验证原手机号';
      //将要发送短信的手机号，验证码类型和弹窗标题发送过去
      this.eventBus.$emit('currencyPhoneCode_user', this.mobilePhone)
    },
    //旧手机号验证通过
    oldValidPass(){
       //查询数据库
      this.getUserInfo();
      this.mobilePhone.verificationType='currency';
      this.mobilePhone.mobilePhone=undefined;
      this.mobilePhone.oldMobilePhone=this.userInfo.mobilePhone;
      this.mobilePhone.phoneTitle='新手机号';
      this.eventBus.$emit('currencyPhoneCode', this.mobilePhone)
    },
    //新手机号验证通过,保存新手机号
    newValidPass(phone){
      if(phone.length>0){
        this.validOldVisible=false;
        //修改新手机号
        this.common.httpPost('修改手机号','/admin/basic/verificationCode/updatePhone',{"mobilePhone":phone}).then((res) => {
              if(res!=undefined){
                this.$message({
                message: '手机号修改成功',
                type: 'success'
              });
              this.getBaseInfo();
              }
            })
      }
    },
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
        //弹窗提示
        this.$confirm('邮箱是您非常重要基本信息，可用于接收重置帐户密码等用途。您确定新的邮箱输入正确，并要进行变更吗？', '信息确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
       //发送到后台修改邮箱
        this.common.httpPost('修改邮箱','/admin/basic/verificationCode/updateEmail',this.form).then((res) => {
              if(res!=undefined){
                this.$message({
                message: '邮箱修改成功',
                type: 'success'
              });
              this.validEmailVisible=false
              this.closeEmailDialog()
              this.getBaseInfo();
              }
            })
      }).catch(() => {});}})},
    closeEmailDialog(){
      this.validEmailVisible=false
      this.form.email=''
    },
    //展示企业信息
    getEnterprise(){
      this.showEterprise = true;
      this.getEnterpriseInfo();
    },
    //查询企业信息
    getEnterpriseInfo(){
       this.common.httpPost('查询企业信息', '/admin/home/enterprise/getBaseInfo', {}).then((res) => {
         res.data.authorizationFilePath=this.common.imgUrlPrefix+res.data.authorizationFilePath;
         res.data.authorizationFilePathImageFit=this.existImgUrl(res.data.authorizationFilePath);
         res.data.certificateFilePath=this.common.imgUrlPrefix +res.data.certificateFilePath;
         res.data.certificateFilePathImageFit=this.existImgUrl(res.data.certificateFilePath);
         res.data.officeSpaceFilePath=this.common.imgUrlPrefix+res.data.officeSpaceFilePath;
         res.data.officeSpaceFilePathImageFit=this.existImgUrl(res.data.officeSpaceFilePath);
         res.data.billboardFilePath=this.common.imgUrlPrefix+res.data.billboardFilePath;
         res.data.billboardFilePathImageFit=this.existImgUrl(res.data.billboardFilePath);
         this.enterprise=res.data;
         console.log(this.enterprise);
              })
    },
    //图片处理自适应
    existImgUrl(params){
      var imageFit='';
      let img = new Image();
      img.src = params;
      if (img.width > img.height) {
          imageFit='fill';
        } else {
          imageFit='contain';
        }
      return imageFit;
    },
    //展示个人中心
    getUserInfo(){
      this.showUserInfo=true;
      this.getBaseInfo();
    },
    //查询个人信息
    getBaseInfo(){
       this.common.httpPost('查询个人信息', '/admin/system/user/getUserInfo', {}).then((res) => {
         if(res!=undefined){
          this.userInfo=res.data;
          this.mobilePhone.mobilePhone=res.data.mobilePhone;
           if(res.data.loginUserType==2){
              this.enterpriseButton=true
           }
         }
        })
    },
    changePassword() {
      //弹出修改密码的窗口
      this.eventBus.$emit('changePassword', true)
    },
    handleCommand(command) {
      if ('logout_click' === command) this.logout_click()
    },
    logout_click() {
      this.$store.dispatch('logout', this.ruleForm).then(() => {
        this.$router.push({ path: '/login' })
      })
    },
    //消息列表页面
    showMessageList(){
      this.eventBus.$emit('messageList', true)
    },
    //登录系统时加载系统消息
    getSystemMessageList(params){
      return
        this.common
        .httpPost(
          '获取系统消息列表',
          '/admin/system/systemMessages/getMessageByRequest',
          {},params
        )
        .then((res) => {
          if(res!=undefined){
              this.systemMessageList=res.data;
              //未读消息的数量
              var count=0;
              for(var i=0;i<this.systemMessageList.length;i++){
                  if(this.systemMessageList[i].didRead==0){
                        count=count+1;
                  }
              }
              this.unreadMessageCount=count

              //修改vuex中的消息集合
              this.$store.dispatch("initMessageList",this.systemMessageList)
              //服务器端的时间与客户端相差的毫秒数
              this.differTime=Date.parse(res.nowTime)-new Date();
              //定时任务   拿出最后一个id
              if(this.systemMessageList.length>0){
                this.lastMsgID=res.data[0].id
              }
              //common中获取消息开关，true_开启    false_关闭
              if(this.common.refreshSystemMessages==true){
                this.timer=setTimeout(this.selectNewMessage,10000);
              }
          }
        })
      },
      //查询数据库中新生成的消息
      selectNewMessage(){
        return
        //看是否退出登录，如果退出，销毁定时器
        if(getToken()==undefined || getToken().indexOf("$") != -1){
        clearTimeout(this.timer)
        return;
        }
        //定时删除过期的消息
         for(var i=0;i<this.systemMessageList.length;i++){
          var dif= Date.parse(this.systemMessageList[i].destructionTime)-new Date();
           if(this.systemMessageList[i].destructionTime!=null && dif<=this.differTime){
             //根据ID删除系统消息
            this.systemMessageList.splice(i, 1);
            i=i-1;
           }
         }
      //查询新生成的消息
      this.common.httpPost('根据ID查询数据库中新生成的消息','/admin/system/systemMessages/getNewMessage',{"id":this.lastMsgID},true,true).then((res) => {
            if(res!=undefined){
                if(res.data.length>0){
                for(var i=0;i<res.data.length;i++){
                  //判断消息标题”是否是“充值金额已到账”
                    if(res.data[i].messageTitle.substring(res.data[i].messageTitle.length-5)=='充值已到账'){
                        //如果是这个，则刷新企业首页的可用余额
                      this.$store.dispatch('initRefushStatusessage', !this.$store.getters.refushStatus)
                    }
                    var x=this.systemMessageList.unshift(res.data[i]);
                    if(i==res.data.length-1){
                        this.lastMsgID=res.data[i].id
                    }
                }
              }
              //查看消息集合中的未读消息的数量
              var count=0;
                for(var i=0;i<this.systemMessageList.length;i++){
                    if(this.systemMessageList[i].didRead==0){
                          count=count+1;
                    }
                }
              this.unreadMessageCount=count
              //改变vuex中的消息集合
              this.$store.dispatch("initMessageList",this.systemMessageList)
              //清除定时器
              clearTimeout(this.timer)
              this.timer=setTimeout(this.selectNewMessage,10000);
              }
        })
      }
  },
  computed: {
        //数据修改了,刷新新数据
        refreshMessageList () {
          return this.$store.getters.updateMessageStatus
        }
  },
  watch:{
     refreshMessageList(newVal,oldVal){
        //先销毁定时器，再刷新新数据
        clearTimeout(this.timer)
        this.getSystemMessageList();
      }
  },
  created(){
    var userStatus=getCookie("userStatus");
    //获取系统消息和是否开启表单验证开关
    this.common.httpPost('获取系统消息和是否开启表单验证开关','/admin/system/systemMessages/getWebAdminSwitch',{},true,true).then((res) => {
        if(res!=undefined){
            this.common.refreshSystemMessages=res.refreshSystemMessages
            this.common.openFormValidate=res.enableFormValidation
          }
        })
    //判断登录人的状态，如果状态为1，获取消息数据
    if(userStatus==1){
        this.getSystemMessageList();
        this.getBaseInfo();
    }

  }
}
</script>

<style lang="scss" scoped>
// style dependency
@import '@/assets/styles/variables.scss';
.img{
  margin: 10px;
}
// 个人中心的修改链接
.el-userInfo-link{
  position:absolute;
 right:20vh !important;
}
.el-form{
      height: 8vh;
}
.userInfoButton{
    position: absolute;
    right: 1vh;
}
//下拉菜单的宽度和用户个人信息相等
.el-dropdown-menu {
  width: 140px;
}
.userInfo{
  padding-bottom: 20px;
}
.user-content{
  height: 36px;
}
.el-dropdown-menu__item:hover{
  background:#f8f8f8!important;
  color:#e4393c!important;
}
.el-dropdown-menu__item:hover i{
  color:#e4393c!important;
}
.user-management {
  display: flex;
  align-items: center;

  > .user {
    // width: 95px;  // ‘欢迎您’前面加用户名，元素长度不够
    display: flex;
    align-items: center;
    height: 18px;
    padding: 0 15px;
    border-left:solid 2px #dee7f3;
    outline: none;
    &.action-full {
      height: 100%;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      cursor: pointer;
    }

    > .avatar {
      width: 24px;
      height: 24px;
      line-height: 24px;
      border-radius: 50%;
      background:#fff;
      color:red;
    }

    > .username {
      font-size: $fontSize;
      margin-left: 5px;
      color: #666666;
      margin-right:5px;
      border-bottom:solid 1px #fff;
    }
    .username:hover{
      color:#e4393c !important;
      // border-bottom:solid 1px #e4393c;
    }
    > .el-icon-caret-bottom{
      color:#888888;
    }
  }
}

.quick-links{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right:30px;
  //首页
  .home{
    height: 18px;
    padding: 0 20px;
    .homename{
      font-size: 14px;
      margin-left: 8px;
      color: #666666;
      border-bottom:solid 1px #fff;
      cursor: pointer;
    }
    .homename:hover{
      color:#e4393c !important;
    }
    .el-icon-s-home{
      color:#888888;
    }
  }
  //信息
  .infonews{
    height: 18px;
    padding: 0 20px;
    border-left:solid 2px #dee7f3;
    position: relative;
    .infoname{
      font-size: $fontSize;
      margin-left: 5px;
      color: #666666;
      margin-right:5px;
      border-bottom:solid 1px #fff;
      cursor: pointer;
    }
    .infoname:hover{
      color:#e4393c !important;
    }
    .el-icon-bell{
      color:#888888;
    }
    .infonum{
      height: 18px;
      width: 18px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      background: #f56c6c;
      color: #fff;
      font-size: 12px;
      border-radius: 50%;
      position: absolute;
      left: 25px;
      top: -9px;
    }
  }
  //设置
  .instal{
    height: 18px;
    // margin-right:50px;
    padding: 0 15px;
    border-left:solid 2px #dee7f3;
    .el-icon-s-tools{
      color:#888888;
    }
    .instalname{
      font-size: 14px;
      margin-left: 8px;
      color: #666666;
       border-bottom:solid 1px #fff;
      cursor: pointer;
    }
    .instalname:hover{
      color:#e4393c !important;
    }
  }

  //个人中心
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainLayout/components/UserManagement/index.vue